import React from 'react'
import { Switch } from '@progress/kendo-react-inputs'

interface Props {
    disabled?: boolean;
    onChange?: any;
    name?: string;
    defaultChecked?: any
    checked?: any
    value?: any
    offlabel?: any
    onLabel?:any
  }
  

const Toggle: React.FC<Props> = ({
    name,
    defaultChecked,
    onChange,
    checked,
    value,
    offlabel,
    onLabel
}) => {


  return (
     <div>
          <Switch
              name={name}
              defaultChecked={defaultChecked}
              onChange={onChange}
              checked={checked}
              value={value}
              offLabel={offlabel}
              onLabel={onLabel}
          />   
      </div>
  )
}

export default Toggle